// User-facing copy (Indonesian). TECH.md §6: copy lives here, never inline in components.
export const commonCopy = {
  brand: "AI Class",
  loading: "Memuat…",
  notFound: {
    code: "404",
    title: "Halaman tidak ditemukan",
    description: "Link yang Anda buka mungkin sudah dipindahkan atau tidak pernah ada.",
    backHome: "Kembali ke beranda",
  },
} as const;
